import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { makeGridGetRowsResponse } from '@cbridge-tools/default-data-grid';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { toApiSort } from '@cbridge-utils/datagrid';
import { MarkupAction } from '../markup.action';
import { MarkupTranslator } from '../markup.translator';

type IDependencies = IClientApiDependencySegment;

export const loadMarkupListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupAction.loadList.started),
  mergeMap((params) => {
    const { resolve, reject, sort, ...payload } = params;

    return dependencies.api.getMarkupList({
      ...payload,
      sort: toApiSort(sort),
    }).pipe(
      mergeMap((response) => {
        const { symbolMarkups, totalCount, filteredCount } = response;

        const items = symbolMarkups.map(MarkupTranslator.fromApiSymbol);
        resolve?.(makeGridGetRowsResponse(items, filteredCount));

        return [
          MarkupAction.loadList.done({ params, result: { totalCount, filteredCount } }),
        ];
      }),
      catchApiError((error) => {
        reject?.(error?.description);
        return [
          MarkupAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
